import { NavMenuKeys } from '@/routes/navMenu';
import { lazyImport } from '@/utils/lazyImport';
import React from 'react';
import { type Route } from '@/routes/route';
import { PageName } from '../constant';

const { Page } = lazyImport(() => import('../index'), 'Page');

export const routes: Route[] = [
  {
    name: PageName,
    path: '/finance/fullExchangeCheckIn',
    element: <Page />,
    module: NavMenuKeys.Finance,
    enable: true,
    order: 13,
  },
];
